import { useNavigate } from "react-router-dom";
import { CollectionForm } from "@univdiam/ui/customComponents/CollectionList/CollectionForm";
import api from "@/http/api";

export default function CollectionAdd() {
  const navigate = useNavigate();

  const handleAddCollection = async (data: any) => {
    try {
      const response = await api.post(`/api/collection/add`, data);

      if (response.status === 201 || response.status === 200) {
        alert("Collection created successfully!");
        navigate("/collection");
      }
    } catch (error) {
      console.error("Error creating group:", error);
      alert("Failed to create group.");
    }
  };

  return (
    <div className="p-6 max-w-2xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">Create New Collection</h1>
      <CollectionForm onSubmit={handleAddCollection} />
    </div>
  );
}
